import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import moment from 'moment';
import _ from 'lodash';

function isDeliveryWorkflowMode(mode) {
  return (
    mode &&
    ['DELIVERY', 'PRIORITY_DELIVERY', 'STANDARD_DELIVERY'].includes(mode)
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  completed: {
    display: 'inline-block',
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}));

function getSteps(costType, statusHistory, currentStatus, activeStep, preferredServiceMode, serviceMode) {
  let statusArray = [];
  if (costType.toLowerCase() === "fixed") {
    let requestedModeOfService = serviceMode ? serviceMode : preferredServiceMode;
    statusArray = ['Created'];
    statusHistory.forEach((status) => {
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "ACCEPTED" && !statusArray.includes('Accepted')) { statusArray.push('Accepted'); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "IN_PROGRESS" && !statusArray.includes('In_Progress')) { statusArray.push('In_Progress'); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "CANCELLED" && !statusArray.includes('Cancelled')) { statusArray.push('Cancelled'); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "REJECTED" && !statusArray.includes('Rejected')) { statusArray.push('Rejected'); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "OUT_FOR_DELIVERY" && !statusArray.includes('Out_for_Delivery')) { statusArray.push('Out_for_Delivery'); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "DELIVERY_DONE" && !statusArray.includes('Delivery_Done')) { statusArray.push('Delivery_Done'); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "READY_FOR_PICKUP" && !statusArray.includes('Ready_for_Pickup')) { statusArray.push('Ready_for_Pickup'); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "PICKUP_DONE" && !statusArray.includes('Pickup_Done')) { statusArray.push('Pickup_Done'); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "COMPLETED" && !statusArray.includes('Completed')) { statusArray.push('Completed'); }
    });

    if (!statusArray.includes('Accepted')) { statusArray.push('Accepted'); }
    if (!statusArray.includes('In_Progress')) { statusArray.push('In_Progress'); }
    if (isDeliveryWorkflowMode(requestedModeOfService)) {
      if (!statusArray.includes('Out_for_Delivery')) { statusArray.push('Out_for_Delivery'); }
      if (!statusArray.includes('Delivery_Done')) { statusArray.push('Delivery_Done'); }
    }
    if (requestedModeOfService === "PICKUP") {
      if (!statusArray.includes('Ready_for_Pickup')) { statusArray.push('Ready_for_Pickup'); }
      if (!statusArray.includes('Pickup_Done')) { statusArray.push('Pickup_Done'); }
    }
    if (!statusArray.includes("Completed")) { statusArray.push('Completed'); }

  } else {
    statusArray = ['Initiated'];
    let requestedModeOfService = serviceMode ? serviceMode : preferredServiceMode;
    statusHistory.forEach(status => {
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "ACCEPTED" && !statusArray.includes("Accepted")) { statusArray.push("Accepted"); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "IN_PROGRESS" && !statusArray.includes("In_Progress")) { statusArray.push("In_Progress"); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "QUOTED" && !statusArray.includes('Quoted')) { statusArray.push('Quoted'); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "QUOTE_DECLINED" && !statusArray.includes('Quote_Declined')) { statusArray.push('Quote_Declined') }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "REJECTED_BY_CONSUMER" && !statusArray.includes('Rejected_by_Consumer')) { statusArray.push('Rejected_by_Consumer') }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "REJECTED" && !statusArray.includes('Rejected')) { statusArray.push('Rejected'); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "CANCELLED" && !statusArray.includes('Cancelled')) { statusArray.push('Cancelled') }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "OUT_FOR_DELIVERY" && !statusArray.includes("Out_for_Delivery")) { statusArray.push("Out_for_Delivery"); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "DELIVERY_DONE" && !statusArray.includes("Delivery_Done")) { statusArray.push("Delivery_Done"); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "READY_FOR_PICKUP" && !statusArray.includes("Ready_for_Pickup")) { statusArray.push("Ready_for_Pickup"); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "PICKUP_DONE" && !statusArray.includes("Pickup_Done")) { statusArray.push("Pickup_Done"); }
      if (status.status && status.status !== null && status.status !== undefined && status.status.toUpperCase() === "COMPLETED" && !statusArray.includes("Completed")) { statusArray.push("Completed"); }
    });

    if (!statusArray.includes('Accepted')) { statusArray.push('Accepted'); }
    if (!statusArray.includes('In_Progress')) { statusArray.push('In_Progress'); }
    if (isDeliveryWorkflowMode(requestedModeOfService)) {
      if (!statusArray.includes('Out_for_Delivery')) { statusArray.push('Out_for_Delivery'); }
      if (!statusArray.includes('Delivery_Done')) { statusArray.push('Delivery_Done'); }
    }
    if (requestedModeOfService === "PICKUP") {
      if (!statusArray.includes('Ready_for_Pickup')) { statusArray.push('Ready_for_Pickup'); }
      if (!statusArray.includes('Pickup_Done')) { statusArray.push('Pickup_Done'); }
    }
    if (!statusArray.includes("Completed")) { statusArray.push('Completed'); }

  }
  return statusArray;
}

export default function HorizontalNonLinearAlternativeLabelStepper(props) {
  const classes = useStyles();
  const steps = getSteps(props.costType, props.serviceRequestDetails.statusHistory, props.serviceRequestDetails.currentStatus, props.activeStep, props.preferredServiceMode, props.serviceMode);

  function isStepComplete(step) {
    return props.completedSteps.has(step);
  }
  // Tracks which raw statusHistory entries have already been matched to a
  // step, so a status shared by multiple raw entries (e.g. duplicate
  // delivery-partner webhook callbacks mapping to the same canonical status)
  // isn't reused across steps.
  const usedStatusIndices = new Set();
  return (
    <div className={classes.root}>
      <Stepper alternativeLabel nonLinear activeStep={props.activeStep}>
        {steps.map((label, index) => {
          let actionDateTime = "";
          let updatedBy = "";
          let userType = ""
          let role = ""
          let photo = ""
          let servicePartnerName = 'Dunzo';
          if (props.serviceRequestDetails && props.serviceRequestDetails.statusHistory) {
            _.remove(props.serviceRequestDetails.statusHistory, (obj) => obj.status === "AWAITING PAYMENT");
          }

          // Match by status VALUE only (not array position) so entries that
          // land out of the fixed step order - duplicate or skipped statuses
          // from delivery-partner webhooks - still land on the right step.
          // Each raw entry is consumed at most once so a repeated status
          // can't get reused across multiple steps.
          let matchedStatus = null;
          props.serviceRequestDetails.statusHistory.forEach((status, indexNo) => {
            if (matchedStatus || usedStatusIndices.has(indexNo)) return;
            if (status.status && label.toLowerCase() === status.status.toLowerCase()) {
              matchedStatus = status;
              usedStatusIndices.add(indexNo);
            }
          });

          if (matchedStatus) {
            const status = matchedStatus;
            if (
              (status.updatedBy.servicePartnerName &&
                status.updatedBy.servicePartnerName !== null &&
                status.updatedBy.servicePartnerName !== undefined &&
                ['Borzo', 'Porter', 'Shadowfax', 'Petpooja'].includes(status.updatedBy.servicePartnerName)) ||
              status.updatedBy.servicePartnerName
            ) {
              servicePartnerName = status.updatedBy.servicePartnerName;
            }
            actionDateTime = moment(status.time).format('DD MMM YYYY hh:mm A');
            updatedBy = status.updatedBy?._id ? `${status.updatedBy?._id?.firstName || ""} ${status?.updatedBy?._id?.lastName || ""}` : "System";
            photo = status.updatedBy?._id?.photo;
            userType = status.updatedBy.userType === 'consumer' ? "Consumer" : (status.updatedBy.userType === 'member') ? "Member" : (status.updatedBy.userType === 'servicePartner') ? "servicePartner" : (status.updatedBy.userType === 'serviceprovider') ? "Service Provider" : (status.isManualDelivery && status.updatedBy.userType === 'admin') ? "Admin (Manual Delivery)" : (status.isManualDelivery && status.updatedBy.userType === "areaManager") ? "AM (Manual Delivery)" : (status.updatedBy.userType === 'Auto') ? "" : (status.updatedBy.userType ? status.updatedBy.userType.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()) : "Admin")
            role = status.updatedBy.role ? status.updatedBy.role.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()) : "";
          }
          const stepProps = {};
          const buttonProps = {};

          buttonProps.optional = <div style={{ display: "grid" }}>
            <Typography variant="caption">{actionDateTime}</Typography>
            {
              updatedBy ?
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <Avatar alt="Action Taken By" src={photo} className={classes.small} />
                  &nbsp;
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant="subtitle2">{userType === "servicePartner" ? servicePartnerName : updatedBy}</Typography>
                    <Typography variant="caption">{role ? role : userType}</Typography>
                  </div>
                </div>
                : null
            }
          </div>;

          return (
            <Step key={label} {...stepProps}>
              <StepButton
                disabled
                completed={isStepComplete(index)}
                {...buttonProps}
              >
                {label}
              </StepButton>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}
